import * as React from 'react'

import { Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import type FiltersForm from 'modules/core/lib/forms/Filters'
import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import WorkScheduleTabs from 'modules/work_schedules/components/Tabs'
import type Schedule from 'modules/work_schedules/store/models/Schedule'

import EmployeesTable from './EmployeesTable'

interface Props {
  loading: boolean
  workSchedule: Schedule
  filtersForm: FiltersForm
  contractVersions: ContractVersions
}

const WorkScheduleEmployees = ({
  loading,
  workSchedule,
  filtersForm,
  contractVersions,
  children,
}: React.PropsWithChildren<Props>) => {
  const { navigation } = useNavigation()

  return (
    <ResponsivePage.Body showHeader={false} variant="wide" loading={loading} error={null}>
      <WorkScheduleTabs contractVersions={contractVersions} />

      <Section.FullWidth
        illustration="group"
        title={i18n.t('settings.work_schedule.employees_tab.tab')}
        description={i18n.t('settings.work_schedule.employees_tab.description')}
        action={{
          label: i18n.t('settings.work_schedule.employees_tab.add'),
          to: navigation.settings.workSchedule.id.employees.add.fullPath({ id: workSchedule.id }),
        }}
      >
        <>
          <EmployeesTable
            filtersForm={filtersForm}
            workSchedule={workSchedule}
            contractVersions={contractVersions}
          />
          {children}
        </>
      </Section.FullWidth>
    </ResponsivePage.Body>
  )
}

export default observer(WorkScheduleEmployees)
